import React, { useEffect, useState, useMemo } from 'react';
import { TextField, Button, Box, DialogActions, DialogContent, DialogTitle
  , useMediaQuery, Dialog, Snackbar, Paper } from '@mui/material';
import { themeQuartz } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useTheme } from '@mui/material/styles';
import { useSaveImportStatusMutation } from '../../services/product';
import * as XLSX from 'xlsx';
import ConfirmDialog from '../tools/comfirmDialog';
import LoadingPage from '../loadingPage';
import moment from 'moment';

export default function ImportExcel({open, setOpen, selectedSMS}) {
  const theme1 = useTheme();
  const fullScreen = useMediaQuery(theme1.breakpoints.down('md'));
	const [loading, setLoading] = useState(false);
  const [saveImportStatus] = useSaveImportStatusMutation();
  const [alert, setAlert] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [columns, setColumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);

  useEffect(() => {
    setGridHeight(window.innerHeight - 210);
  }, []);

  const handleClose = () => {
    setOpen(false);
    setExcelData([]);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if(open == "DiscountCCS"){
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, {
            //range: 0,
            raw: false,
            dateNF: "yyyy-mm-dd"
          });
          const filtered = json.map(row => {
            if (!row || typeof row !== 'object') return null;
            const keys = Object.keys(row);
            return {
              Style: String(row[keys[0]] || '').trim(),
              Color: String(row[keys[1]] || '').trim(),
              Discount: String(row[keys[2]] || '').replace('%', '').trim()
            };
          }).filter(Boolean);
          setExcelData(filtered);
          filtered.length > 0 &&
            getColumns(filtered[0]);
        };
        reader.readAsArrayBuffer(file);
      }
    }
    else{
      const onlyNumbers = file.name.replace(/[^0-9]/g, '');
      const launchMonth = onlyNumbers.substring(0, 6);
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, {
            //range: 0,
            raw: false,
            dateNF: "yyyy-mm-dd"
          });
          
          const filtered = json.map(row => ({
            FromDate: launchMonth.substring(2, 6) + '/' + launchMonth.substring(0, 2) + '/01',
            Concatenate: row["Concatenate_1"]?.trim()||row["Concatenate"]?.trim(),
            Status: row["Status_1"]?.trim()||row["Status"]?.trim()?.substring(0, 1),
          })).filter(row => row.Concatenate && row.Status && row.Status != "(blank)");

          setExcelData(filtered);
          filtered.length > 0 &&
            getColumns(filtered[0]);
        };
        reader.readAsArrayBuffer(file);
      }
    }
  };

  const getColumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key, width: 150
      }
    });
    setColumns(cols);
  }

  const myTheme = themeQuartz.withParams({
    wrapperBorder: false,
    headerRowBorder: false,
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const onSave = async() =>{
		setLoading(true);
    try {
      setConfirm(false);
      let error = false;
			const formData = new FormData();
      formData.append("table", open);
			formData.append("data", JSON.stringify(excelData));
			const dt = await saveImportStatus(formData).unwrap();
			if(dt[0].ERROR) error = dt[0].ERROR;
      
      if(error)
        setAlert(error);
      else{
        setAlert(`Đã cập nhật ${excelData.length} dòng!`);
				setExcelData([]);
        setOpen(false);
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
		setLoading(false);
  }

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" sx={{textAlign: 'center', fontWeight: 600}}>
          {open}
        </DialogTitle>
                {/* <Divider /> */}
        <DialogContent>
          { (loading) && <LoadingPage /> }
          <input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} />
            <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
              <AgGridReact enableCellTextSelection={true} ensureDomOrder={true}
                rowData={excelData}
                columnDefs={columns}
                pagination={true}
                paginationPageSize={200}
                paginationPageSizeSelector={[200, 500, 1000]}
                theme={theme}
              />
            </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            CLOSE
          </Button>
          <Button onClick={()=>setConfirm(`Xác nhận hệ thống sẽ ghi đè dữ liệu ${open=='UpdateStatus'?'tháng':''} ${open=='UpdateStatus'?moment(excelData[0]?.FromDate).format('MM/YYYY'):''}`)} autoFocus>
            SAVE
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />

      <ConfirmDialog confirm={confirm} setConfirm={setConfirm} onConfirm={onSave}/>
    </React.Fragment>
  );
}